import { apiGet, apiPost, apiPatch } from './client.js';

export const getConfig = () => apiGet('/config');
export const testConfigValue = (key, value) => apiPost(`/config/${key}/test`, { value });
export const setConfigValue = (key, value) => apiPatch(`/config/${key}`, { value, tested: true });
